import { Directive, HostListener } from '@angular/core';
import { generateRandomIdentifier } from '../ui.service';

declare var jQuery: any;
@Directive({
  selector: '[appFocusControl]'
})
export default class FocusControlDirective {

  hash = '';
  constructor() {
    // Para saber cuantas instancias de la directiva se generan
    this.hash = generateRandomIdentifier();

    // Se elimina el aspa de la modal del ciruito de focos con el tabulador
    jQuery('.p-dialog-header-icon').each(function () {
      jQuery(this).attr('tabindex', -1)
      // console.log(this.hash + ": Se ha desactivado el foco del botón cerrar de la modal.!!");
    });

  }


  @HostListener('document:keydown.Tab', ['$event'])
  public perform(event) {

    // console.log('appFocusControl-->');
    //console.log(this.hash + 'appFocusControl.event.timestamp:' + event.timestamp);

    // Se buscan diálogos abiertos
    // A partir del segundo nivel se controla el evento keydown.Tab
    // Se cancela el evento en el primero recivido, si no ocurren multiplicados por cada modal y no se puede tabular
    let dynamicdialogs = jQuery('body').find('p-dynamicdialog');
    if (dynamicdialogs.length && dynamicdialogs.length > 1) {

      event.preventDefault(); // ¿¿??
      // Detiene la capilaridad del evento,
      // evitando que se disparen los eventListeners de los elementos que contengan a quien dispara el evento.
      event.stopImmediatePropagation();
      // Se envía el foco al siguiente elemento por que se ha cancelado el evento y no lo hace por defecto.
      if (event.target.nextElementSibling && !jQuery(event.target.nextElementSibling).hasClass('p-inputgroup-addon')) {
        event.target.nextElementSibling.focus();
        // console.log('Avanza el foco dentro de la modal.');

      } else {
        // 1.
        // Cuando no hay un siguiente definido por que:
        // - Llega al último elemento que empieze por el primero.
        // - o cuando no está definido el siguiente --> formplyca editorconfig
        // - o en un add-on de un input que intenta enfocar y no es focusable, buscamos el siguiente
        // console.log('Buscar siguiente foco dentro el contenido modal.');
        let modal = dynamicdialogs.last();
        //reindex focus elements, set new tabindex
        //reindexTabIndex();

        focusControl('.p-dialog-content', modal);
      }
    }
    // console.log(this.hash + 'appFocusControl<--');
  }


}


// 2.
// Busca el último diálogo abierto y establece el foco en el siguiente elemento focusable
export function focusControl(dialogTag, modalObj) {
  // console.log(dialogTag + '*********************************************');

  let modalDialogContent = jQuery(modalObj)
    .find(dialogTag);

  // console.log(modalDialogContent);
  if (modalDialogContent.length > 0) {
    //setFocusToFirstItemInModal(modalDialogContent);
    setFocusToNextItemInModal(modalDialogContent, event.target);
  }
  // console.log(dialogTag + ' *********************************************');

}

// 3.
// Establece el foco en el siguiente elemento focusable del diálogo pasado por parámetro
export function setFocusToNextItemInModal(modalDialogContent, item) {
  // get list of all children elements in given object
  if (modalDialogContent && modalDialogContent.find) {
    let modalElements = modalDialogContent.find('*');

    // set the focus to the first keyboard focusable item
    let focusableElements = modalElements
      .filter(focusableElementsString)
      .filter(':visible');

    let focusElement = focusableElements[0];
    let encontrado = false;
    focusableElements.each(function () {
      if (this == item) {
        // console.log("Encontrado");
        focusElement = jQuery(this);
        encontrado = true;
      } else if (encontrado) {
        focusElement = this;
        encontrado = false;
      }

    });

    if (encontrado) {
      focusElement = focusableElements[0];
    }
    // console.log('Elemento para el foco:');
    // console.log(focusElement);
    focusElement.focus();
  }
}









// No se usan, solo para pruebas -->



export function setFocusToFirstItemInModal(modalDialogContent) {
  // get list of all children elements in given object
  if (modalDialogContent && modalDialogContent.find) {
    let o = modalDialogContent.find('*');

    // set the focus to the first keyboard focusable item
    let focusElement = o
      .filter(focusableElementsString)
      .filter(':visible')
      .first();

    focusElement.focus();
  }
}

export function reindexTabIndex() {
  // console.log('configureModalFocusTrap-->');
  // attach a listener to redirect the tab to the modal window
  // if the user somehow gets out of the modal window


  // console.log(event);
  // console.log(jQuery(this));


  let v3 = jQuery('body')
    .find('p-dynamicdialog');

  if (v3.length) {

    let v3last = jQuery('body').find('p-dynamicdialog').last();
    //tabIndexFocusControl(event, '.p-dialog-content', v3last, v3.length + '0');
    tabIndexFocusControl(event, '.p-scrollpanel-content', v3last, '1');

    //tabIndexFocusControl(event, '.p-dialog-content', v3last, '1');

  } else {
    // console.log('No hay p-dynamicdialog');
  }
  // console.log(v3);

  // console.log('<--configureModalFocusTrap *********************************************');
}




let focusableElementsString =
  'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';

export function tabIndexFocusControl(event, focusBlockName, focusBlockObj, startIndex) {
  // console.log(focusBlockName + '*********************************************');

  let index = startIndex;
  jQuery(focusBlockObj).find(focusBlockName).find('*')
    .filter(focusableElementsString)
    .filter(':visible').each(function () {
      if (jQuery(this).hasClass('p-inputgroup-addon')) {

        jQuery(this).attr('tabindex', -1);

      } else {
        jQuery(this).attr('tabindex', index);
        index++;
      }
    });
  jQuery('.p-dialog-header-icon').each(function () {
    jQuery(this).attr('tabindex', -1)
    // console.log(this.hash + ": Se ha desactivado el foco del botón cerrar de la modal.!!");
  });
  // console.log(focusBlockName + ' *********************************************');
}
